export default "__VITE_ASSET__AxFtcwPs__"